/**
 * Issue #309 — 管理员「清理 SOP/ASR/AI 卡死状态」展示纯逻辑（无 React / 网络依赖，可单测）。
 *
 * dry-run / apply 后端只回脱敏计数 + 状态分布；这里把它们整理成可读摘要与可渲染的分布行，
 * 屏幕组件只负责接线真实 API 与渲染，绝不在组件里散落计数/排序魔法。
 */
import type { TrainingRecoveryActionSummary } from './types';

export function recoveryActionableCount(summary: TrainingRecoveryActionSummary): number {
  return summary.aiSyncedCompleted + summary.aiFailed + summary.asrFailed;
}

export function hasActionableRecovery(summary: TrainingRecoveryActionSummary): boolean {
  return recoveryActionableCount(summary) > 0;
}

export function describeRecoverySummary(summary: TrainingRecoveryActionSummary): string {
  return (
    `同步完成 ${summary.aiSyncedCompleted} 题、` +
    `AI 终态化 ${summary.aiFailed} 题、` +
    `ASR 终态化 ${summary.asrFailed} 题、` +
    `保留处理中 ${summary.leftActive} 题、` +
    `幂等跳过 ${summary.idempotentSkipped} 题`
  );
}

export function statusDistributionRows(
  distribution: Record<string, number> | null | undefined,
): Array<{ status: string; count: number }> {
  if (!distribution) return [];
  return Object.entries(distribution)
    .filter(([, count]) => typeof count === 'number' && count > 0)
    .map(([status, count]) => ({ status, count }))
    .sort((a, b) => b.count - a.count || a.status.localeCompare(b.status));
}
